<!-- 当前时间组件 -->
<template>
  <div class='nowtime'>
       <div id='time'>{{monAndDate}}   {{week}}</div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
  // 这里存放数据
    return {
      nowTime: '',
      nowDate: '',
      monAndDate: '',
      week: '',
      timeid: 0
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    timeFormate (timeStamp) {
      let year = new Date(timeStamp).getFullYear()
      let month = new Date(timeStamp).getMonth() + 1
      let date = new Date(timeStamp).getDate() < 10 ? '0' + new Date(timeStamp).getDate() : new Date(timeStamp).getDate()
      let hh = new Date(timeStamp).getHours() < 10 ? '0' + new Date(timeStamp).getHours() : new Date(timeStamp).getHours()
      let mm = new Date(timeStamp).getMinutes() < 10 ? '0' + new Date(timeStamp).getMinutes() : new Date(timeStamp).getMinutes()
      this.nowDate = year + '-' + month + '-' + date + ''
      this.monAndDate = month + '月' + date + '日' + ' '
      this.nowTime = hh + ':' + mm + ' ' + ' '
      let dateString = this.nowDate
      let dateObject = new Date(dateString)
      this.week = dateObject.getDay()
      switch (this.week) {
        case 0:
          this.week = '星期日'
          break
        case 1:
          this.week = '星期一'
          break
        case 2:
          this.week = '星期二'
          break
        case 3:
          this.week = '星期三'
          break
        case 4:
          this.week = '星期四'
          break
        case 5:
          this.week = '星期五'
          break
        case 6:
          this.week = '星期六'
          break
        default:
          break
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.timeFormate(new Date())
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {
    //   销毁定时器
    clearInterval(this.timeid)
  }, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
    #time {
      color: #7c7c7c;
      font-family: Hiragino Sans GB W3;
      float: left;
      font-size: 16px;
      margin-left: 20px;
    }
</style>
